export const MODAL_LIGHTBOX_CLASSNAME = "web3modal-modal-lightbox";
export const MODAL_CONTAINER_CLASSNAME = "web3modal-modal-container";
export const MODAL_HITBOX_CLASSNAME = "web3modal-modal-hitbox";
export const MODAL_CARD_CLASSNAME = "web3modal-modal-card";
export const MODAL_MAIN_CLASSNAME = "web3modal-modal-main";
export const MODAL_CLOSE_CLASSNAME = "web3modal-modal-close";
export const MODAL_HEADER_CLASSNAME = "web3modal-modal-header";
export const MODAL_PROVIDERS_CLASSNAME = "web3modal-modal-providers";
export const MODAL_DOWNLOAD_CLASSNAME = "web3modal-modal-download";
export const MODAL_LINK_CLASSNAME = "web3modal-modal-link";

export const PROVIDER_WRAPPER_CLASSNAME = "web3modal-provider-wrapper";
export const PROVIDER_CONTAINER_CLASSNAME = "web3modal-provider-container";
export const PROVIDER_ICON_CLASSNAME = "web3modal-provider-icon";
export const PROVIDER_CONTENT_CLASSNAME = "web3modal-provider-content";
export const PROVIDER_NAME_CLASSNAME = "web3modal-provider-name";
export const PROVIDER_DESCRIPTION_CLASSNAME = "web3modal-provider-description";
export const PROVIDER_ARROW_CLASSNAME = "web3modal-provider-arrow";

export const CONNECT_BUTTON_CLASSNAME = "web3modal-connect-button";
